var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningSysmbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 42,
    viewBox: "0 0 52 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5469 38.1338L28.179 1.2871C28.179 1.2871 27.5501 0 26 0C24.4499 0 23.821 1.2871 23.821 1.2871L0.453143 38.1338C0.453143 38.1338 0 38.7357 0 39.5484C0 40.9029 1.1081 42 2.47619 42H49.5238C50.8919 42 52 40.9029 52 39.5484C52 38.7357 51.5469 38.1338 51.5469 38.1338Z",
    fill: "url(#paint0_linear_1073_46628)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0171 37.0968C25.1108 37.0968 24.363 36.8247 23.7736 36.2804C23.1843 35.7362 22.8896 35.0779 22.8896 34.3032C22.8896 33.4954 23.1868 32.8334 23.7823 32.3174C24.3766 31.8013 25.1219 31.5439 26.0171 31.5439C26.9234 31.5439 27.6662 31.805 28.2432 32.3259C28.8214 32.8481 29.1098 33.5064 29.1098 34.3032C29.1098 35.111 28.8238 35.7778 28.2518 36.3049C27.6798 36.832 26.9345 37.0968 26.0171 37.0968ZM28.7681 13.4644L28.1726 28.3886C28.154 28.8446 27.7752 29.205 27.3146 29.205H24.6168C24.155 29.205 23.7761 28.8434 23.7588 28.3862L23.1955 13.4632C23.1769 12.9814 23.5669 12.5806 24.0535 12.5806H27.9114C28.3979 12.5806 28.7879 12.9814 28.7681 13.4644Z",
    fill: "url(#paint1_radial_1073_46628)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1073_46628",
    x1: -385.977,
    y1: -433.461,
    x2: 37.1374,
    y2: 56.6809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB705"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1073_46628",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.8052 12.3121) scale(27.6875 27.4128)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSysmbol);
export default __webpack_public_path__ + "static/media/warning Sysmbol.4c77596a4c77121c451d45d7cb288786.svg";
export { ForwardRef as ReactComponent };